module.exports = __webpack_public_path__ + "static/img/lenglian.a7a7e957.png";